module.exports = __webpack_public_path__ + "img/millemedia-desktop.7d6beb20.jpg";